// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3JLUY","options":"AnswerScale_options__3nC4c","selected":"AnswerScale_selected__1Cfyq"};